/*
 * Cart drawer + cart page, only when a deposit pre-order is in the cart
 * ([data-lp-deferred] is rendered by snippets/lucid-cart-due.liquid):
 *  1. Checkout+ button (Free Returns + Package Protection app) shows the full order total.
 *     Relabel it with what is charged today: its own total minus the balance billed when it ships.
 *  2. Cart page only: hide Shopify's deferred-purchase notice. Checkout shows the same consent
 *     (twice) at the point of payment.
 * Looks inside open shadow roots and button/input values, since apps often render there.
 */
(function () {
  'use strict';
  if (window.__lucidCartPreorderLoaded) return;
  window.__lucidCartPreorderLoaded = true;

  var NOTICE = 'One or more of the items in your cart is a deferred';
  var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function toCents(str) { return Math.round(parseFloat(str.replace(/,/g, '')) * 100); }

  /* Every text node, input and shadow root under root (open shadow roots only). */
  function walk(root, onText, onInput) {
    var stack = [root];
    while (stack.length) {
      var node = stack.pop();
      if (node.nodeType === 3) { onText(node); continue; }
      if (node.nodeType !== 1 && node.nodeType !== 11) continue;
      if (node.nodeType === 1) {
        if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') continue;
        if (node.tagName === 'INPUT') onInput(node);
        if (node.shadowRoot) {
          stack.push(node.shadowRoot);
          watch(node.shadowRoot);
        }
      }
      for (var i = node.childNodes.length - 1; i >= 0; i--) stack.push(node.childNodes[i]);
    }
  }

  function relabel(scope, deferred, currency) {
    var replaceIn = function (text) {
      if (text.indexOf('today') !== -1) return null;
      var m = text.match(/(Checkout\+)\s*\$([\d,]+\.\d{2})/);
      if (!m) return null;
      var today = toCents(m[2]) - deferred;
      return today > 0 ? text.replace(m[0], m[1] + ' · ' + money(today, currency) + ' today') : null;
    };
    walk(scope, function (n) {
      var text = n.nodeValue;
      var out = replaceIn(text);
      if (out) { n.nodeValue = out; return; }
      // "Checkout+" and "$906.96" in separate pieces of the same button
      var amt = text.match(/^\s*\$([\d,]+\.\d{2})\s*$/);
      if (!amt) return;
      var host = n.parentElement && n.parentElement.closest('button, a, [role="button"]');
      if (!host || (host.textContent || '').indexOf('Checkout+') === -1) return;
      var today = toCents(amt[1]) - deferred;
      if (today > 0) n.nodeValue = text.replace(amt[0].trim(), money(today, currency) + ' today');
    }, function (input) {
      var out = input.value && replaceIn(input.value);
      if (out) input.value = out;
    });
  }

  function hideNotice(scope) {
    walk(scope, function (n) {
      if (n.nodeValue.indexOf(NOTICE) === -1) return;
      var el = n.parentElement;
      // climb to the element that holds the whole notice, but never past the checkout form area
      while (el && el.parentElement && (el.parentElement.textContent || '').trim() === (el.textContent || '').trim()) el = el.parentElement;
      if (el && !el.querySelector('button, input[type="submit"]')) el.style.setProperty('display', 'none', 'important');
    }, function () {});
  }

  var queued = false;
  function run() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('[data-lp-deferred]').forEach(function (data) {
        var deferred = parseInt(data.dataset.lpDeferred, 10);
        if (!(deferred > 0)) return;
        var scope = data.closest('cart-drawer, #CartDrawer, .f-cart-drawer, #main-cart-footer') || document.body;
        relabel(scope, deferred, data.dataset.currency);
        if (data.closest('#main-cart-footer')) hideNotice(scope);
      });
    });
  }

  function watch(root) {
    if (observed) { if (observed.has(root)) return; observed.add(root); }
    new MutationObserver(run).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value'] });
  }

  watch(document.documentElement);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  run();
})();
